<template>
  <div class="doc-box">
    <div class="tags-box">
      <a
        v-for="item in tags"
        :key="item.key"
        @click="activeName = item.key"
        :href="item.href"
        :class="{ active: activeName == item.key }"
      >
        {{ item.label }}
      </a>
    </div>
    <img
      v-for="item in imgList"
      :key="item.id"
      :id="item.id"
      :src="require('@/assets/' + item.img + '.png')"
    />
  </div>
</template>

<script>
export default {
  name: "Doc",
  data() {
    return {
      showDownloadWay: false,
      activeName: "registrationCertificate",
      tags: Object.freeze([
        {
          href: "#registrationCertificate",
          key: "registrationCertificate",
          label: "注册说明",
        },
        {
          href: "#softwareRecharge",
          key: "softwareRecharge",
          label: "软件充值",
        },
        {
          href: "#translationSkills",
          key: "translationSkills",
          label: "翻译技巧",
        },
      ]),
      imgList: Object.freeze([
        {
          id: "registrationCertificate",
          img: "registration-certificate",
        },
        {
          id: "softwareRecharge",
          img: "software-recharge",
        },
        {
          id: "translationSkills",
          img: "translation-skills",
        },
      ]),
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.doc-box {
  background-color: #fff;
  min-height: 100vh;
  padding-bottom: 146px;
  .tags-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 83px;
    background: #ffffff;
    box-shadow: 0px 10px 27px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    a {
      border-radius: 18px;
      line-height: 24px;
      text-align: center;
      padding: 6px 29px;
      font-size: 16px;
      font-weight: 400;
      color: #000;
      margin: 0 40px;
      &.active {
        font-size: 17px;
        font-weight: 500;
        color: #ffffff;
        background: linear-gradient(90deg, #5d6c7b 0%, #323840 100%);
        box-shadow: 0px 6px 16px 0px rgba(65, 69, 75, 0.41),
          inset 0px -2px 0px 0px rgba(0, 48, 142, 0.22);
      }
    }
  }
  #registrationCertificate,
  #softwareRecharge,
  #translationSkills {
    width: 100%;
    height: 409px;
    margin: 32px auto;
    display: block;
  }
  #translationSkills {
    margin-bottom: 0;
  }
}
</style>
